import React from 'react';
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';
import { tableCss } from './TableCss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { history } from '../../helpers';

function IdeaApproverTable() {
  const tableClasses = tableCss();
  const { ideaDetailsFlux } = useSelector((state) => state.fluxIdeas);
  const { t } = useTranslation();

  const columns = [
    { id: 'nome', label: t('nome') },
    { id: 'email', label: t('email') },
    { id: 'businessUnit', label: t('unidade_de_negocio') },
    { id: 'local', label: t('local') },
    { id: 'occupationArea', label: t('area_de_atuacao') },
  ];

  return (
    <Paper className={tableClasses.paperRoot}>
      <TableContainer>
        <Table
          stickyHeader
          aria-label="users table"
          classes={{ root: tableClasses.table }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  classes={{ root: tableClasses.tableCellHeader }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {ideaDetailsFlux?.currentStepFlux?.evaluatorsInStep?.map(item => (
              <TableRow
                hover
                key={item._id}
                style={{ cursor: 'pointer' }}
                classes={{ root: tableClasses.tableRow }}
              >
                <TableCell 
                  classes={{ root: tableClasses.tableCellRadiusLeft }}
                  onClick={() => history.push(`/profile/${item._id}`)}
                >
                  {item.name}
                </TableCell>
                <TableCell classes={{ root: tableClasses.tableCell }}>
                  {item.email}
                </TableCell>
                <TableCell classes={{ root: tableClasses.tableCell }}>
                  {item.businessUnitLocals?.businessUnit}
                </TableCell>
                <TableCell classes={{ root: tableClasses.tableCell}}>
                  {item.businessUnitLocals?.local}
                </TableCell>
                <TableCell classes={{ root: tableClasses.tableCellRadiusRight }}>
                  {item.businessUnitLocals?.occupationArea}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export { IdeaApproverTable };

